<template>
  <div class="call-handler">
    <div class="call-handler-contents">
      <!-- <h6>{{ third_party_hold_status ? "ON HOLD" : "CONNECTED" }}</h6> -->
      <h6>{{ call_state }}</h6>


      <!-- <div v-if="outboundCall && call_state == 'CONNECTING'">
        <h5>
          Outgoing to: {{ caller_name }}
          <span class="border-box">{{ queue_name }}</span>
        </h5>
      </div> -->
      <div >
        <h5>
          {{third_party_caller_name}}  <span class="border-box">{{ queue_name }}</span>
        </h5>
      </div>
      <h6>
        {{ third_party_caller_number }}
        <span :state="time" v-if="call_state == 'CONNECTED'"
          >{{ displayHours }}:{{ displayMinutes }}:{{ displaySeconds }}</span
        >
      </h6>

       <div class="call-handle-buttons-container">
        <b-button
          size="sm"
          @click="onholdToggleThirdPartyCall()"
          id="tooltip-target-hold"
          pill
          class="call-control-buttons"
          :variant="third_party_hold_status ? 'primary' : 'secondary'"
          v-b-tooltip.hover.bottom
          :title="third_party_hold_status?'Play':'Hold'"
          :disabled="
            call_state ? call_state == 'CONNECTING' : call_state != 'CONNECTING'
          "
        >
          <font-awesome-icon :icon="third_party_hold_status ? 'play' : 'pause'" size="sm" />
        </b-button>
        <!-- <b-tooltip
          target="tooltip-target-hold"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Hold/Play</b-tooltip
        > -->

        <b-button
          size="sm"
          @click="OnMuteToggle()"
          id="tooltip-target-mute"
          pill
          class="call-control-buttons"
          :variant="mute_status ? 'primary' : 'secondary'"
          :disabled="
            call_state ? call_state == 'CONNECTING' : call_state != 'CONNECTING'
          "
        >
          <font-awesome-icon
            :icon="mute_status ? 'microphone-alt-slash' : 'microphone-alt'"
            size="sm"
          />
        </b-button>
        <b-tooltip
          target="tooltip-target-mute"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Mute</b-tooltip
        >




  
    
          <!-- <b-button
          size="sm"
          @click="OnQuickTransfer()"
          id="tooltip-target-qc"
          pill
          class="call-control-buttons"
          variant="secondary"
          :disabled="
            call_state ? call_state == 'CONNECTING' : call_state != 'CONNECTING'
          "
        >
          <font-awesome-icon icon="random" size="sm" />
        </b-button> 
        <b-tooltip
          target="tooltip-target-qc"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Quick Connect</b-tooltip
        > -->

        <b-button
          size="sm"
          @click="OnNumberPadToggle()"
          id="tooltip-target-dp"
          pill
          class="call-control-buttons"
          :variant="ivrDialPad?'primary':'secondary'"
          :disabled="
            call_state ? call_state == 'CONNECTING' : call_state != 'CONNECTING'
          "
        >
          <font-awesome-icon icon="th" size="sm" />
        </b-button>
        <b-tooltip
          target="tooltip-target-dp"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Dial Pad</b-tooltip
        >

        <b-button
          size="sm"
          @click="addManualNotes()"
          id="tooltip-target-ml"
          pill
          class="call-control-buttons"
          variant="secondary"
        >
          <font-awesome-icon icon="sticky-note" size="sm" />
        </b-button>
        <b-tooltip
          target="tooltip-target-ml"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Add Notes</b-tooltip
        >


        <!-- <b-button
          size="sm"
          @click="addManualNotes()"
          id="tooltip-target-ml"
          pill
          class="call-control-buttons"
          variant="secondary"
        >
          <font-awesome-icon icon="sticky-note" size="sm" />
        </b-button>
        <b-tooltip
          target="tooltip-target-ml"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Add Notes</b-tooltip
        > -->

        <b-button
          @click="onEndThirdPartyCall()"
          id="tooltip-target-ec"
          class="call-control-buttons"
          size="sm"
          pill
          variant="danger"
        >
          <font-awesome-icon icon="phone-slash" size="sm" />
        </b-button>

        <b-tooltip
          target="tooltip-target-ec"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >End Call</b-tooltip>

          <div v-if="ivrDialPad==true" class="call-handler-dialpad-container">

          <b-form-input v-model="number" type="tel" placeholder="Enter IVR"> 
         <font-awesome-icon icon="backspace" @click="removeDigits()" size="md" /></b-form-input>
<div  class="dialpad-button-container">
<div v-if="ivrNumber.length>0" class="backspace">
 
</div>

<div class="button-row">
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('1')"
@mousedown="dialTone(697.0, 1209.0)"
@mouseup="stop()"
>
<div class="dialpad-number">1</div>
<div class="dialpad-filler"></div>
</b-button>
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('2')"
@mousedown="dialTone(697.0, 1336.0)"
@mouseup="stop()"
>
<div class="dialpad-number">2</div>
<div class="dialpad-letters">ABC</div>
</b-button>
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('3')"
@mousedown="dialTone(697.0, 1477.0)"
@mouseup="stop()"
>
<div class="dialpad-number">3</div>
<div class="dialpad-letters">DEF</div>
</b-button>
</div>
<div class="button-row">
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('4')"
@mousedown="dialTone(770.0, 1209.0)"
@mouseup="stop()"
>
<div class="dialpad-number">4</div>
<div class="dialpad-letters">GHI</div>
</b-button>
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('5')"
@mousedown="dialTone(770.0, 1336.0)"
@mouseup="stop()"
>
<div class="dialpad-number">5</div>
<div class="dialpad-letters">JKL</div>
</b-button>
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('6')"
@mousedown="dialTone(770.0, 1477.0)"
@mouseup="stop()"
>
<div class="dialpad-number">6</div>
<div class="dialpad-letters">MNO</div>
</b-button>
</div>
<div class="button-row">
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('7')"
@mousedown="dialTone(852.0, 1209.0)"
@mouseup="stop()"
>
<div class="dialpad-number">7</div>
<div class="dialpad-letters">PQRS</div>
</b-button>
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('8')"
@mousedown="dialTone(852.0, 1336.0)"
@mouseup="stop()"
>
<div class="dialpad-number">8</div>
<div class="dialpad-letters">TUV</div>
</b-button>
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('9')"
@mousedown="dialTone(852.0, 1477.0)"
@mouseup="stop()"
>
<div class="dialpad-number">9</div>
<div class="dialpad-letters">WXYZ</div>
</b-button>
</div>
<div class="button-row">
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('*')"
@mousedown="dialTone(941.0, 1209.0)"
@mouseup="stop()"
>
<div class="dialpad-number">*</div>
</b-button>
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('0')"
@mousedown="dialTone(941.0, 1336.0)"
@mouseup="stop()"
>
<div class="dialpad-number">0</div>
<div class="dialpad-letters">+</div>
</b-button>
<b-button
variant="outline-secondary"
class="dialpad-button"
@click="keyDial('#')"
@mousedown="dialTone(941.0, 1477.0)"
@mouseup="stop()"
>
<div class="dialpad-number">#</div>
</b-button>


</div>






    </div>
          </div>
          
          



      </div> 



    </div>
    </div>

</template>

<script>
import dayjs from "dayjs";
import store from "../../../store";
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";
import {
  onholdToggleInitialCall,
  onMuteToggle,
  onEndIntialCall,
  onholdToggleThirdPartyCall,
  onEndThirdPartyCall

} from "../../../lib/CallActions.js";

import Dialer from "./../../Dialer/index.vue";

export default {
  name: "IncomingCall",
  data() {
    return {
      pageUrl: "home",
      ivrDialPad:false,
      ivrNumber:"",
      number:"",
      numberPad:false,
      ivrDialPad:false,
      dialPadToggleStatus: true,
      contextClass: null,
      context: null,
      oscillator1: null,
      oscillator2: null,
      gainNode: null,
      dialedNumber: '',
    };
  },
  mounted(){
    this.contextClass =
      window.AudioContext ||
      window.webkitAudioContext ||
      window.mozAudioContext ||
      window.oAudioContext ||
      window.msAudioContext
    if (this.contextClass) {
      this.context = new this.contextClass()
    }
  },
  components: {
    Dialer,
  },
  methods: {
    OnholdToggleInitialCall() {
      onholdToggleInitialCall();
    },
    OnMuteToggle() {
      onMuteToggle(this.mute_status);
    },
    OnDialPadToggle() {
      this.$store.dispatch("actions/callSubNavigation", "dialpad");
      this.$store.dispatch("call/updateNotesEditor", false);

    },
    OnQuickTransfer() {
      this.$store.dispatch("actions/callSubNavigation", "quickconnects");
    },
    addManualNotes() {
    
        this.$store.dispatch("call/updateNotesEditor", true);
     
      this.ivrDialPad = false;
    },
    OnEndIntialCall() {
      onEndIntialCall();
    },
    onholdToggleThirdPartyCall(){
      console.log("this is thirdpartyhold status",this.third_party_hold_status);
      onholdToggleThirdPartyCall()
    },
    onEndThirdPartyCall(){
      onEndThirdPartyCall()
    },
    
    // callerName() {
    //   if (this.caller_name == 'Unknown Caller') {
    //     return (this.caller_name = 'Calling...')
    //   } else {
    //     return this.caller_name
    //   }
    //},
    showRemaining() {
      const timer = setInterval(() => {
        const startTime = new Date(this.start_time).getTime();
        const endTime = new Date(this.end_time).getTime();
      });
    },
    OnNumberPadToggle(){
      console.log(this.ivrDialPad)
      if(this.ivrDialPad == false){
        this.ivrDialPad = true
      }else{
        this.ivrDialPad = false

      }
      this.$store.dispatch("call/updateNumberPad", false);

    },
    addManualLog() {
      let passData = {};
      passData.action = "ADD_MANUAL_LOGS";
      passData.agentId = store.getters.agent_username;
      passData.contactId = store.getters.contact_id;
      passData.callerName = store.getters.caller_name;
      passData.callerName = store.getters.caller_name;
      passData.callerNumber = store.getters.caller_number;
      passData.callerId = store.getters.caller_id;
      // passData.start_time = store.getters.start_time;
      // passData.end_time = store.getters.end_time;
      // passData.callDuration = store.getters.callDuration;
      passData.callType = store.getters.fs_call_type;
      passData.calledTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
      // passData.DestroyedFlag = store.getters.on_destroyed_flag;
      console.log(passData);
      parent.postMessage(passData, "*");
    },
    keyDial(number){
      if ((number) => 0 && number <= 9) {
        this.number = this.number + number
        this.$store.dispatch('call/setIvrNumber', this.ivrNumber + ivrNumber)
      }
    },
    dialTone(freq1, freq2) {
      var vm = this
      vm.oscillator1 = vm.context.createOscillator()
      vm.oscillator1.type = 0
      vm.oscillator1.frequency.value = freq1
      vm.gainNode = vm.context.createGain
        ? vm.context.createGain()
        : vm.context.createGainNode()
      vm.oscillator1.connect(vm.gainNode, 0, 0)
      vm.gainNode.connect(vm.context.destination)
      vm.gainNode.gain.value = 0.1
      vm.oscillator1.start ? vm.oscillator1.start(0) : vm.oscillator1.noteOn(0)
      vm.oscillator2 = vm.context.createOscillator()
      vm.oscillator2.type = 0
      vm.oscillator2.frequency.value = freq2
      vm.gainNode = vm.context.createGain
        ? vm.context.createGain()
        : vm.context.createGainNode()
      vm.oscillator2.connect(vm.gainNode)
      vm.gainNode.connect(vm.context.destination)
      vm.gainNode.gain.value = 0.1
      vm.oscillator2.start ? vm.oscillator2.start(0) : vm.oscillator2.noteOn(0)
      console.log('the dial tone was clicked')
    },
    stop() {
      var vm = this
      vm.oscillator1.disconnect()
      vm.oscillator2.disconnect()
    }

    
  },
  computed: {
    ...mapGetters([
      "call_state",
      "caller_name",
      "queue_name",
      "caller_number",
      "mute_status",
      "hold_status",
      "start_time",
      "end_time",
      "displayHours",
      "displayMinutes",
      "displaySeconds",
      "outboundCall",
      "third_party_caller_name",
      "third_party_caller_number",
      "third_party_hold_status",
      "notes_editor"
    ]),
    time() {
      if (this.call_state == "CONNECTED") {
        function startTime() {
          this.displaySeconds += 1;
        }
        setInterval(startTime, 1000);
      }
    },
  },
};
</script>

<style scoped>
.border-box {
  border: 1px solid grey;
  border-radius: 0.77rem;
  color: rgb(0, 0, 0);
  font-size: 0.75rem;
  padding: 0 0.35rem;
  background-color: #aaacad;
}
.call-handle-buttons {
  width: 110px;
  margin: 0 5px;
}

.call-handler {
  display: table;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.call-handler-contents {
  display: table-cell;
  margin: 0;
}

.call-control-buttons {
  margin: 0 0.85rem 0 0;
}

.call-handle-buttons {
  width: 110px;
  margin: 0 5px;
}

.call-handle-buttons-container {
  margin-left: 0.6rem;
  margin-bottom: 0.5rem;
}

.call-handler-dialpad-container {
  margin-top: 10px;
  height: 350px;
  width: 100%;
  /* border-color: #2c5cc5;
  border-style: double; */
}

.dialpad-container {
  text-align: center;
}

.dialpad-letters {
  font-size: 10px;
  margin-top: 10px;
  color: #ccc5c5;
}

.dialpad-filler {
  visibility: hidden;
}

.btn {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 0.5;
  border-radius: 0.25rem;
}

.dialpad-button {
  width: 23%;
  height: 55px;
  margin-right: 5px;
  margin-left: 5px;
}
.button-row {
  margin-top: 10px;
}
</style>
